export default __webpack_public_path__ + "buysearchsell/images/buysearchsell_black_logo.svg";